import Header from "@components/Header/Header";
import i18n from "@i18n/i18n";
import { Box } from "@mui/material";
import { observer } from "mobx-react";
import { Outlet } from "react-router-dom";

const SettingsLayout = observer(() => {
  return (
    <>
      {/*<Header message="CarbonIQ" />*/}
      <Header message={i18n.t("main.header")} />
      <Box sx={{ display: "flex", flexGrow: 1 }}>
        <Outlet />
      </Box>
    </>
  );
});

export default SettingsLayout;
